import { CHAIN_USDC_ADDRESSES, CHAIN_WETH_ADDRESSES } from "../../tokens.js";
import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { AAVE_V3_COLLECTOR, ERC20_BALANCE_OF_REFERENCE_CALLDATA, SWAP_QUOTE_AMOUNT, } from "../fixture-inputs.js";
export const ARBITRUM_TEST_CONFIG = {
    balance: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
    },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.arbitrum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getBlockByNumberArbitrum",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getBalanceArbitrum",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.arbitrum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getTokenBalanceArbitrum",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.arbitrum,
        fixture: "getBlockByHashArbitrum",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getBlockTransactionsArbitrum",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getTransfersArbitrum",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.arbitrum,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "simulateCallArbitrum",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.arbitrum,
        fixture: "traceTransactionArbitrum",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.arbitrum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getTokenMetadataArbitrum",
    },
    tokenAllowanceQuery: {
        token: CHAIN_USDC_ADDRESSES.arbitrum,
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getTokenAllowanceArbitrum",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.arbitrum,
        fixture: "getReceiptArbitrum",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.arbitrum,
        fixture: "getTransactionByHashArbitrum",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasArbitrum",
    },
    codeQuery: {
        address: CHAIN_USDC_ADDRESSES.arbitrum,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum,
        fixture: "getCodeArbitrum",
    },
    logsQuery: {
        address: CHAIN_USDC_ADDRESSES.arbitrum,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.arbitrum),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.arbitrum),
        fixture: "getLogsArbitrum",
    },
    aaveV3Query: { address: AAVE_V3_COLLECTOR.arbitrum, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getAaveV3UserPositionsArbitrum" },
    compoundV3Query: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getCompoundV3UserPositionsArbitrum" },
    lidoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getLidoUserPositionsArbitrum" },
    morphoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getMorphoUserPositionsArbitrum" },
    curveLlamaLendQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getCurveLlamaLendArbitrum" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getApprovalsArbitrum" },
    pendleV2InfoQuery: { fixture: "getPendleV2InfoArbitrum" },
    curvePoolsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getCurvePoolsArbitrum" },
    curveLlamaLendMarketsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getCurveLlamaLendMarketsArbitrum" },
    uniswapV3QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.arbitrum, tokenOut: CHAIN_USDC_ADDRESSES.arbitrum, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getUniswapV3QuoteArbitrum" },
    uniswapV4QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.arbitrum, tokenOut: CHAIN_USDC_ADDRESSES.arbitrum, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.arbitrum, fixture: "getUniswapV4QuoteArbitrum" },
    approvalsRevokeQuery: { address: VITALIK, token: CHAIN_USDC_ADDRESSES.arbitrum, spender: CHAIN_WETH_ADDRESSES.arbitrum, fixture: "getApprovalsRevokeArbitrum" },
};
